<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    items?: string[]
  }>(),
  {
    title: 'Fitur yang Disukai Ribuan Toko Shopify',
    items: () => [
      'Ongkir Otomatis di Halaman Checkout',
      'Resi & Label Siap Cetak',
      'Tracking Real-Time',
      'Request Pickup Multi-Kurir',
      'Smart Address Checker',
      'Support Shopify Themes',
      'Dedicated Onboarding & Support Team'
    ]
  }
)
</script>

<template>
  <UiSectionWrapper
    :title="title"
    hero-image="/images/plugin-shopify-banner-3.webp"
    :items="items"
    class="py-12"
    :with-action="false"
  />
</template>
